export const BUILD_VERSION = '1777647652';
